import axios from './axios'
import config from '../config'

export default {
    listUserLogs(params) {
        return axios({
            url: config.backendUrl + '/op/admin/user-logs',
            method: 'GET',
            params
        })
    }
}
